import InputDecorator from '@enerex/unified-ui-react/form/InputDecorator';
import ColorPicker from '@enerex/unified-ui-react/form/ColorPicker';
import RadioGroup from '@enerex/unified-ui-react/form/RadioGroup';
import ElectricityIcon from '@enerex/unified-ui-react/icons/ElectricityIcon';
import GasIcon from '@enerex/unified-ui-react/icons/GasIcon';

const COMMODITIES = ['Electric', 'Natural Gas'];
const LookupSpecialField = ({ field, control, disabled }) => {
    if (field.type === 'checkbox') return <InputDecorator name={field.name} control={control}
        containerClass={['isProcurement', 'hasRevenueForecast'].includes(field.name) ? 'settings-lookup__inline-checkbox' : undefined}
        render={({ field: input }) => <label className="settings-lookup__check">
            <input type="checkbox" name={input.name} ref={input.ref} checked={Boolean(input.value)}
                onChange={event => input.onChange(event.target.checked)} onBlur={input.onBlur} disabled={disabled} />
            {field.label}
        </label>} />;
    if (field.type === 'color') return <InputDecorator name={field.name} control={control} label={field.label}
        render={({ field: input, fieldState }) => <ColorPicker value={input.value || ''}
            onChange={input.onChange} disabled={disabled} invalid={fieldState.invalid}
            className="settings-lookup__form-select" />} />;
    return <InputDecorator name={field.name} control={control}
        rules={{ validate: value => !field.required || Boolean(String(value ?? '').trim()) || field.label + ' is required.' }}
        render={({ field: input, fieldState }) => {
            const names = input.value && !COMMODITIES.includes(input.value) ? [...COMMODITIES, input.value] : COMMODITIES;
            return <RadioGroup className="settings-lookup__commodity-options" aria-label="Commodity"
                name={input.name} value={input.value} onChange={input.onChange} onBlur={input.onBlur}
                disabled={disabled} invalid={fieldState.invalid} inline
                options={names.map(name => {
                    const Icon = name === 'Electric' ? ElectricityIcon : name === 'Natural Gas' ? GasIcon : null;
                    return {
                        value: name,
                        title: name,
                        'aria-label': name,
                        label: Icon ? <Icon aria-hidden="true" color={name === 'Electric' ? 'var(--ct-warning, #ffc35a)' : 'var(--ct-success, #0acf97)'} /> : name,
                    };
                })} />;
        }} />;
};
export default LookupSpecialField;
